import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import { buy } from './models/buy'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    checkinKey: '',
    buy,
    addressIsPrepopulated: false,
    defaultLegalese: [
      'By signing below, I represent that',
      'I am the owner of these items and I',
      'have the right to sell them.'
    ].join(' '),
    raiStore: {
      id: '',
      store_number: '',
      store_preferences: {
        buys_require_license: false
      },
      buy_config: {
        buys_require_license: false,
        legalese: '',
        marketing_snippet: ''
      }
    },
    customer: '',
    driverLicense: {
      expire_date: '',
      number: '',
      state: ''
    },
    winmarkStore: {}
  },
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js